import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import Import_constants from "../Constants/ImportConstants";

let impotTypeList = [];
let importConfig = [];
let getTemplate = [];
let uploadDataResult = [];
class ImportExcelStore extends EventEmitter {
  getImportExcelResult() {
    return impotTypeList;
  }

  setImportExcelResult(result) {
    impotTypeList = result;
  }

  getImportConfigResult() {
    return importConfig;
  }

  setImportConfigResult(result) {
    importConfig = result;
  }

  getTemplateResult() {
    return getTemplate;
  }

  setTemplateResult(result) {
    getTemplate = result;
  }

  getUploadDataResult() {
    return uploadDataResult;
  }

  setUploadDataResult(result) {
    uploadDataResult = result;
  }

  emitChange(eventName) {
    this.emit(eventName);
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case Import_constants.GET_IMPORT_TYPE_SUCCESS:
        this.setImportExcelResult(action.result);
        break;
      case Import_constants.GET_IMPORT_TYPE_FAILURE:
        this.setImportExcelResult(action.result);
        break;
      case Import_constants.GET_IMPORT_CONFIG_ON_ID_SUCCESS:
        this.setImportConfigResult(action.result);
        break;
      case Import_constants.GET_IMPORT_CONFIG_ON_ID_FAILURE:
        this.setImportConfigResult(action.result);
        break;
      case Import_constants.GET_IMPORT_TEMPLATE_SUCCESS:
        this.setTemplateResult(action.result);
        break;
      case Import_constants.GET_IMPORT_TEMPLATE_FAILURE:
        this.setTemplateResult(action.result);
        break;
      case Import_constants.UPLOAD_TEMPLATE_DATA_SUCCESS:
        this.setUploadDataResult(action.result);
        break;
      case Import_constants.UPLOAD_TEMPLATE_DATA_FAILURE:
        this.setUploadDataResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}
const importExcelStore = new ImportExcelStore();
dispatcher.register(importExcelStore.handleCallback.bind(importExcelStore));
export default importExcelStore;
